module.exports = __webpack_public_path__ + "img/TZS09701.0cfc81fd.jpeg";